export const readLocalStorage = (key) => {
    return JSON.parse(localStorage.getItem(key));
};
export const writeLocalStorage = ({ key, data, }) => {
    const dataToWrite = typeof data === "string" ? data : JSON.stringify(data);
    localStorage.setItem(key, dataToWrite);
};
export const deleteLocalStorage = (key) => {
    localStorage.removeItem(key);
};
//# sourceMappingURL=browserUtils.js.map